const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");

class InsuranceModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `insurance-module ${cssVariableKey}`);
    this.contentHash = {};
    this.typingIndicator = null;
  }

  handle(type, value, reference) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(value);
    if (!_elm) return;
    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());

    if (value.status !== "typing") {
      Scroller.scrollToElm(_elm, () => {
        _elm.focus();
      });
    }
  }

  handleOnMessage(value) {
    let component = null;
    if (value.format === "empty") return null;

    let identifier = value.values.id;

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];
      const question = this.contentHash[identifier][1];
      question.updateAnswer(value.values, this.clearAfterId.bind(this));
    } else if (!this.contentHash[identifier]) {
      component = new Block({
        data: value.values,
      });

      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
      } else {
        this.contentHash[identifier] = [Object.keys(this.contentHash).length, component];
      }
    } else if (this.contentHash[identifier]) {
      if (
        this.contentHash[identifier][1]._option._element.updateSuggestions &&
        value.values.suggestions
      ) {
        this.contentHash[identifier][1]._option._element.updateSuggestions(
          value.values.suggestions,
        );
      } else {
        let ch = this.contentHash[identifier];
        this.elContainer.removeELM(ch[1]);

        component = new Block({
          data: value.values,
        });

        this.contentHash[identifier] = [Object.keys(this.contentHash).length, component];
      }
    } else {
      // TODO: do we need this cache?
      // component = this.contentHash[value.id][1];
    }

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  clearAfterId(id) {
    const index = this.contentHash[id][0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;

    this.parent && this.parent.clearAfterId && this.parent.clearAfterId(this.value.id);
  }

  showMore(elm) {
    if (elm) {
      const height = getWindowHeight();
      const bound = elm.getBoundingClientRect();

      if (bound.height > height) {
        ScrollNotification.attachElement(elm);
      }
    }
  }
}

module.exports = InsuranceModule;
